module.exports = __webpack_public_path__ + "img/transitions-white.7601cc3d.svg";